import { JQueryInput } from "./types";
import { getValue } from "./skyward.ui.controls";

type FieldValue = { name: string, value: string | number; };

window.skyward.base.registerScript("dataobjectviewer_getFieldValues", function (skyward, $)
{
    skyward.dataobjectviewer = skyward.dataobjectviewer || {};
    skyward.dataobjectviewer.getFieldValues = async function (container)
    {
        const values = {};

        const namedInputs = container.find("[name]").not(".doNotPost");
        $.extend(values, await getFromItems(namedInputs, skyward.dataobjectviewer.getFieldValueFromNamedInput));

        const editableBrowses = container.find(".editablebrowse");
        $.extend(values, await getFromItems(editableBrowses, getFieldValueFromEditableBrowse));

        const repeaters = container.find(".repeater");
        $.extend(values, await getFromItems(repeaters, getFieldValueFromRepeater));

        // Account for htmlViewers (iframes)
        const iframePromises = container.find(".htmlViewer").not(".js-ignoreIFrameContents").toArray().map(function (elem)
        {
            const iframe = $(elem);
            return skyward.iframeListener.getFieldValues(iframe);
        });
        const iframeFieldValues = await Promise.all(iframePromises);
        $.extend(values, {}, ...iframeFieldValues);
        return values;

        function getFromItems(items: JQuery, valueFunc: (input: HTMLElement) => Awaited<FieldValue | undefined> | Promise<FieldValue | undefined>)
        {
            return Promise.all($.map(items, valueFunc)).then((nameValues) =>
            {
                const values: { [key: string]: any; } = {};
                nameValues.forEach(function (namevalue) { if (!namevalue) { return; } values[namevalue.name] = namevalue.value; });
                return values;
            });
        }
    };

    skyward.dataobjectviewer.getFieldValueFromNamedInput = function (field: JQueryInput): FieldValue | undefined
    {
        const jqField = $(field);

        const name = jqField.attr("name");
        if (!name)
        {
            return;
        }

        const isDatepicker = jqField.hasClass("datepicker");
        const hasNonstandardValues = jqField.hasClass("relativeDate");

        let value = getValue(jqField);

        if (isDatepicker && !hasNonstandardValues)
        {
            if (skyward.datepicker.isValidDateObject(value))
            {
                value = $.datepicker.formatDate("mm/dd/yy DD", value);
            }
            else if ((jqField.val() as string).trim() === "")
            {
                value = "";
            }
            else
            {
                value = new Date(NaN).toString();
            }

            // Dates posted to the server that aren't serialized to JSON need to have their format changed.
            // The default date .toString() posts in a format not recognized by C#'s DateTime parse.
            value = skyward.extensions.encodeHtml(value);
        }
        else
        {
            value = typeof value === "object" ? JSON.stringify(value) : value;
        }

        return { name: name, value: value };
    }

    function getFieldValueFromEditableBrowse(browse: JQueryInput): FieldValue
    {
        const jqBrowse = $(browse);

        const fieldValue =
        {
            name: jqBrowse.attr("id")!,
            value: JSON.stringify(jqBrowse.data("editablebrowsedata"))
        };

        return fieldValue;
    }

    function getFieldValueFromRepeater(repeater: JQueryInput): Promise<FieldValue>
    {
        const jqRepeater = $(repeater);

        if (jqRepeater.hasClass("js-dovAdaptableRepeater"))
        {
            return getFieldValueFromAdaptableRepeater(jqRepeater);
        }

        // Legacy Repeater Save
        const fieldValue =
        {
            name: jqRepeater.attr("id")!,
            value: JSON.stringify(jqRepeater.data("savedata"))
        };

        return Promise.resolve(fieldValue);
    }

    async function getFieldValueFromAdaptableRepeater(adaptableRepeater: JQuery): Promise<FieldValue>
    {
        const jqAdaptableRepeater = $(adaptableRepeater);

        type ItemValue = {
            Data: { [key: string]: any; };
            Key?: string;
        };

        const itemizedValues = await Promise.all(jqAdaptableRepeater.children(".js-dovAdaptableRepeaterItem")
            .filter(function () { return skyward.changeTracking.isDirty($(this)); })
            .map(async function ()
            {
                const editableItem = $(this);

                const returnObj: ItemValue = { Data: await skyward.dataobjectviewer.getFieldValues(editableItem) };

                const key = editableItem.data("key");
                if (key !== undefined)
                {
                    returnObj.Key = key;
                }

                return returnObj;
            })
        );

        const fieldValue =
        {
            name: jqAdaptableRepeater.attr("name")!,
            value: JSON.stringify(itemizedValues)
        };

        return fieldValue;
    }

    skyward.dataobjectviewer.disableButtons = function (dovId)
    {
        $("#" + dovId + "_save").attr('disabled', 'disabled').removeClass("dirty");
        $("#" + dovId + "_saveBack").attr('disabled', 'disabled').removeClass("dirty");
        $("#" + dovId + "_cancel").attr('disabled', 'disabled').removeClass("dirty");
    };

    skyward.dataobjectviewer.enableButtons = function (dovId)
    {
        $("#" + dovId + "_save").attr('disabled', null).addClass("dirty");
        $("#" + dovId + "_saveBack").attr('disabled', null).addClass("dirty");
        $("#" + dovId + "_cancel").attr('disabled', null).addClass("dirty");
    };
});
